import { formatMoney } from "@shopify/theme-currency";
import {responsiveImageTag} from "./images";

const POPULATE_MODE_REPLACE = 'replace',
    POPULATE_MODE_APPEND = 'append';

const PLACEHOLDER_IMAGE_URL = 'https://cdn.shopify.com/s/images/admin/no-image-compact.gif';

export class ProductGrid {
    constructor(loader, grid, popup) {
        this.loader = loader;
        this.grid = grid;
        this.popup = popup;

        this.handleQuickAddToCartClick = this.handleQuickAddToCartClick.bind(this);
        this.handleSwatchesColor = this.handleSwatchesColor.bind(this);
        grid.on('mousedown', '.quick-add-to-cart-link', this.handleQuickAddToCartClick);
        grid.on('mousedown', '.swatcher-color-option-popup', this.handleSwatchesColor);

        // this.internacitionBundlePrice();

    }

    handleQuickAddToCartClick(e) {
        const { popup } = this, link = jQuery(e.target),
            productHandle = link.data('product-handle'),
            bundleDiscount = link.data('bundle-product-discount'),
            bundleHandle = link.data('bundle'),
            frequency = link.data('frequency');
        if (typeof bundleDiscount === 'undefined') {
            // $('.v4-add-to-cart-popup .v4-product-block .header .pricing').css('display', 'none');
            // $('.v4-add-to-cart-popup .v4-product-block .header .pricing').html(' ');
        }

        if (!productHandle && !bundleHandle)
            return;
        popup.container.find('.v4-add-to-cart-popup').removeAttr('data-popup-variant-name');
        popup.container.find('.v5-bundle-upsell-popup-heading').text(' ');
        popup.container.find('.v5-bundle-upsell-placeholder-collection').html(' ');
        popup.container.find('.bundle-pane').addClass('d-none');
        popup.container.find('.product-pane').removeClass('d-none');
        popup.setProductHandle(productHandle, bundleDiscount, frequency);
        popup.container.find('.step-button.up').prop('disabled', false);
        popup.show();
        e.preventDefault();
        e.stopPropagation();
    }

    // I think we dont use this anywhere, but we need to check this properly ---
    populate(products, mode = POPULATE_MODE_REPLACE) {
        const
            { grid } = this,
            tilesHtml = products.map(this.renderTile);

        if (mode === POPULATE_MODE_REPLACE) {
            grid.html(tilesHtml);
        } else if (mode === POPULATE_MODE_APPEND) {
            jQuery(tilesHtml).appendTo(grid);
        }
    }

    handleSwatchesColor(e) {
        const {popup} = this,
            link = jQuery(e.target),
            productHandle = link.data('product-handle-swatch'),
            productColor = link.data('handle-color'),
            bundleDiscount = link.data('bundle-product-discount'),
            product = popup.productBlock.product;
        popup.container.find('.v5-bundle-upsell-popup-heading').text(' ');
        popup.container.find('.v5-bundle-upsell-placeholder-collection').html(' ');
        popup.container.find('.bundle-pane').addClass('d-none');
        popup.container.find('.product-pane').removeClass('d-none');
        popup.container.find('.v4-add-to-cart-popup').removeAttr('data-popup-variant-name');
        popup.container.find('.free-gifts-verbiage').addClass('d-none');

        popup.container.find('.v4-add-to-cart-popup').attr('data-popup-variant-name', productColor);
        if (typeof bundleDiscount === 'undefined') {
            // $('.v4-add-to-cart-popup .v4-product-block .header .pricing').css('display', 'none');
            // $('.v4-add-to-cart-popup .v4-product-block .header .pricing').html(' ');
        }
        if (!productHandle)
            return false;

        popup.setProductHandle(productHandle, bundleDiscount);
        popup.show();

        this.currentColor = productColor;

        let timeOutCount = 0;
        const handleAwait = () => {
            if (popup.state == 'ready') {
                const select = popup.popup.find('.variant-select');
                const selected = select.find(`option:contains("${productColor}")`);
                select.find('option:selected').attr('selected', false);
                selected.change();
                selected.attr('selected', 'selected');
                $('[data-swatches="Color"]').find(`[data-swatch-handle="${productColor}"]`).click();
            } else {
                window.setTimeout(() => {
                    timeOutCount += 1;
                    if (timeOutCount < 50) {
                        handleAwait();
                    }
                }, 100);
            }
        }
        handleAwait();

        e.preventDefault();
        e.stopPropagation();
    }

    // internacitionBundlePrice() {
    //     console.log('internacitionBundlePrice function triggered');
    //     if(country_code_localization != 'US') {
    //         const bundleTiles = $('.v4-product-tile--bundle'),
    //             currencyRate = Shopify.currency.rate;
            
    //         for(let i = 0; i < bundleTiles.length; i++) {
    //             const bundleMsrpSelector = $(bundleTiles[i]).find('.comparison-price'),
    //                 bundlePriceSelector = $(bundleTiles[i]).find('.current-price'),
    //                 bundleMsrp = parseFloat(bundleMsrpSelector.data('bundle-msrp')),
    //                 bundlePrice = parseFloat(bundlePriceSelector.data('bundle-price')),
    //                 convertedBundleMsrp = bundleMsrp * currencyRate,
    //                 convertedBundlePrice = bundlePrice * currencyRate;
                    
    //                 bundleMsrpSelector.text(formatMoney(convertedBundleMsrp, window.moneyFormat));
    //                 bundlePriceSelector.text(formatMoney(convertedBundlePrice, window.moneyFormat));

    //         }
    //     }
    // }

    // I think we dont use this anywhere, but we need to check this properly ---
    renderTile(product) {
        const
            handle = product.handle(),
            title = product.title(),
            url = product.url(),
            featured = product.featuredImage(null, PLACEHOLDER_IMAGE_URL),
            collections = product.formatCollections(),
            pricing = product.formatPricing(null, {comparison: true, html: true}),
            saving = product.formatSaving(),
            imgTag = responsiveImageTag(featured);

        return `<div class="v4-product-tile" data-product-handle="${handle}">
            <div class="v4-product-tile-body">
                ${saving ? `<div class="discount">${saving}</div>` : ''}
                <div class="image-frame">
                    <a href="${url}">${imgTag}</a>
                </div>
                <div class="links">
                    <a class="details-link" href="${url}">More<br/> Details</a>
                    <a class="quick-add-to-cart-link"
                        data-product-handle="${handle}"
                        href="#">Quick Add<br/> to Cart</a>
                </div>
            </div>
            <div class="v4-product-tile-details">
                ${collections ? `<h6 class="collections">${collections}</h6>` : ''}
                <h4 class="title"><a href="${url}">${title}</a></h4>
                <div class="price">${pricing}</div>
            </div>
        </div>`;
    }
}
